import ContractSpecialistModal from './ContractSpecialistModal';

export default ContractSpecialistModal;
